//@flow
import * as Immutable from 'immutable';

import {
    Metadata,
    GeocodedLocation
} from 'common/models/flow/GeocodedLocation';
import type {
    MetadataModelType,
    GeocodedLocationModelType
} from 'common/models/flow/GeocodedLocation';
import { LatLng } from './LatLng';
import { AutoSortAddress } from './AutoSortRequest';

class InternalMetadata extends Metadata {
    static fromJS(json: MetadataModelType): InternalMetadata {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalGeocodedLocation extends GeocodedLocation {
    static fromJS(json: GeocodedLocationModelType): InternalGeocodedLocation {
        const state: Object = Object.assign({}, json);
        state.address = AutoSortAddress.fromJS(state.address);
        state.metadata = InternalMetadata.fromJS(state.metadata);
        return new this(Immutable.Map(state));
    }

    get metadata(): InternalMetadata {
        return this._state.get('metadata');
    }

    get latLng(): LatLng {
        return this._state.get('latLng');
    }

    get address(): AutoSortAddress {
        return this._state.get('address');
    }
}

export {
    InternalMetadata as Metadata,
    InternalGeocodedLocation as GeocodedLocation
};
